<template>
  <div>
    <b-row>
      <b-col cols="1">
        <b-card>
          <b-card-body>
            <b-row>
              <h3>Logik</h3>
            </b-row>
            <b-row>
              <b-col>
                <b-row v-for="lt in logictypes" :key="lt.name">
                  <b-button block variant="outline-secondary" @click="SelectLogicType(lt)">{{
                    lt.description
                  }}</b-button>
                </b-row>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col>
        <logictype v-if="selLogicType" v-bind:logictype="selLogicType"></logictype>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { Api } from "../../lib/api";
import logictype from "./logictype";
const api = new Api();

export default {
  name: "logictypelist",
  components: { logictype },
  data() {
    return {
      logictypes: [],
      selLogicType: null,
    };
  },
  created() {    
    //const url = "/api/apiConfiguration/GetLogicTypeList";
    const url="/api/Configuration/GetLogicTypeList";
    api.get(url).then((res) => {
      this.logictypes = res.data;
    });
  },
  methods: {
    SelectLogicType(lt) {
      this.selLogicType = lt;
    }
  }
};
</script>